import axiosInstance from './axiosInstance'

export type FollowUpType   = 'CALL' | 'MEETING' | 'DEMO' | 'SITE_VISIT' | 'OTHER'
export type FollowUpStatus = 'PENDING' | 'DONE' | 'CANCELLED'

export interface AuditUser {
  id: string; name: string; email: string; avatarUrl: string | null
}

export interface DealFollowUp {
  id: string; dealId: string; dealName?: string | null; title: string | null; type: FollowUpType
  scheduledAt: string; endTime: string | null; notes: string | null
  reminderMinutes: number | null; status: FollowUpStatus; outcome: string | null
  assignedTo: AuditUser | null; createdBy: AuditUser | null
  completedAt: string | null; createdAt: string; updatedAt: string
}

export interface CreateDealFollowUpPayload {
  title?: string; type: FollowUpType; scheduledAt: string
  endTime?: string; notes?: string; reminderMinutes?: number; assignedToId?: string
}

export interface CompleteDealFollowUpPayload { outcome?: string }

export const dealFollowUpsApi = {
  getAll: (dealId: string) =>
    axiosInstance.get<{ data: DealFollowUp[] }>(`/deals/${dealId}/follow-ups`).then(r => r.data.data),
  getAllForCalendar: (lobIds?: string[]) =>
    axiosInstance.get<{ data: DealFollowUp[] }>('/deals/follow-ups', { params: lobIds?.length ? { lobIds: lobIds.join(',') } : undefined }).then(r => r.data.data),
  create: (dealId: string, payload: CreateDealFollowUpPayload) =>
    axiosInstance.post<{ data: DealFollowUp[] }>(`/deals/${dealId}/follow-ups`, payload).then(r => r.data.data),
  complete: (dealId: string, fuId: string, payload: CompleteDealFollowUpPayload = {}) =>
    axiosInstance.patch<{ data: DealFollowUp[] }>(`/deals/${dealId}/follow-ups/${fuId}/complete`, payload).then(r => r.data.data),
  cancel: (dealId: string, fuId: string) =>
    axiosInstance.patch<{ data: DealFollowUp[] }>(`/deals/${dealId}/follow-ups/${fuId}/cancel`).then(r => r.data.data),
}
